import React, { useState,useEffect } from 'react';
import {Box,Typography,Button, Snackbar} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {styled, useTheme} from '@mui/material/styles'
import { useNavigate,Navigate } from 'react-router-dom';
import { add_test } from '../Redux/testSlice';
import { Alarm, ArrowCircleRightOutlined, ArrowDropDownOutlined, CalendarTodayOutlined, CopyAllRounded, FileOpenTwoTone, FormatAlignCenter, NumbersTwoTone, QuizOutlined, Remove } from '@mui/icons-material';
import { FileOpen, TitleRounded } from '@mui/icons-material';
import { add_assessment } from '../Redux/templatesSlice';
import CardViewDialog from './CardViewDialog';
import MultiInput from './MultiInput';
import axios from 'axios';
import { add_job } from '../Redux/jobSlice';
import EditorText from './EditorText';

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography  style={{fontWeight:500,fontSize:13,color:'white',marginTop:9}}> {displayText} </Typography>
}


const ContainerBox = styled(Box, {
})(({ theme}) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
},
minHeight:350,
maxHeight:500
})
);

const MatchDialog = ({visible,setVisible,data,setNewData})=>{

const theme = useTheme()
const user = useSelector(state => state?.auth.user);
const job = useSelector(state => state?.job.job);
const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
const [loading,setLoading] = useState(false)
const dispatch = useDispatch()
const [results, setResults] = useState([]);
const [imageData, setImageData] = useState("https://");
const [description, setDescription] = useState(job?.description);
const [showModal, setShowModal] = useState(false);
const [matching, setMatching] = useState(false);
const [isMatched, setIsMatched] = useState(false);
const [hasMatched, setHasMatched] = useState(false);
const [open, setOpen] = React.useState(false);
const [message, setMessage] = React.useState("");
const [analyzeData, setAnalyzeData] = useState({});
const navigate = useNavigate()

const onOpen = () => {
	setVisible(true);
};
const onClose = () => {
	setVisible(false);
};

async function handleMatch(){
try {

    setMatching(true)

    const send_data = {
        description:description,
        first_name:data?.user?.first_name,
        id:job?.id,
        email:data?.email,
        toSelect:true
    }

    console.log(send_data)

    const match = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}cv/match-resume`,send_data,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":`Bear ${user?.accessToken}`
        }
    }).catch(err=>{
        setMessage("Error while matching, please try later")
        setOpen(true)
        setMatching(false)
        console.log(err)
    })

    if (match?.status == 200 && match?.data?.success) {

        const userData = job?.applicants?.filter(item=>item?.email === data?.email)
        const filterData = job?.applicants?.filter(item=>item?.email !== data?.email)

        const usrData = {
            ...userData[0],
            status:match?.data?.data?.isMatch ? "accepted" : "rejected"
        }
        const newData = [...filterData,usrData]

        setNewData(newData)

        dispatch(add_job({
            ...job,
            applicants:newData
        }))

        if (match?.data?.data?.isMatch) {
            setMessage("This Resume match this job")
            setOpen(true)
            setVisible(false)
            setMatching(false)
            setIsMatched(true)
            setHasMatched(true)
        } else {
            setMessage("This Resume do not match this job")
            setOpen(true)
            setAnalyzeData(match?.data?.data)
            setHasMatched(true)
            setIsMatched(false)
            setMatching(false)
        }
    } else {
        setMessage(match?.data.message)
        setOpen(true)
        setMatching(false)
    }
} catch (error) {
    console.log(error)
}
}

return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"left"}}>
		<Snackbar 
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }} 
            message={message} 
            onClose={()=>{setOpen(false)}}
            open={open} 
            autoHideDuration={2000}
        />
        <DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<FileOpen fontSize='small'/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Match a candidate
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{minWidth:{xs:300,md:500},justifyContent:"center",textAlign:"center",background:theme.palette.background.default}}>
			<ContainerBox justifyContent="center" alignItems="center" width="100%">
                <Box justifyContent="center" alignItems="center" width="100%" p={1}>
                    {
                    (!isMatched && hasMatched) ? (
                        <Box ml={3} textAlign="left">
                            <Typography mb={1} mt={1} style={{fontSize:13,fontWeight:400,fontFamily:"dinofans"}}>
                                Resume description
                            </Typography>
                            <Typography color="white" ml={1} fontSize={12} sx={{whiteSpace:"pre-wrap"}}>
                                {analyzeData?.description}
                            </Typography>
                            <Typography mb={1} mt={1} style={{fontSize:13,fontWeight:400,fontFamily:"dinofans"}}>
                                Missing Skills
                            </Typography>
                            <ol>
                                {analyzeData?.missingSkills?.map((item,index)=>(
                                    <li key={index} style={{color:"#fff",fontSize:11}}>
                                            {item}
                                    </li>
                                    ))
                                }
                            </ol>
                            <Typography mb={1} mt={1} style={{fontSize:13,fontWeight:400,fontFamily:"dinofans"}}>
                                Current Skills
                            </Typography>
                            <ol style={{textAlign:"left"}}>
                                {analyzeData?.matchSkills?.map((item,index)=>(
                                    <li key={index} style={{color:"#fff",fontSize:11}}>
                                            {item}
                                    </li>
                                    ))
                                }
                            </ol>
                        </Box>
                    ) 
                    :
                     <>
                        <Box width="100%">
                            <EditorText
                                data={description}
                                setData={setDescription}
                                width="95%"
                                label="Description"
                                isRequired={true}
                            />
                        </Box>
                        <Box mt={2} textAlign="left" display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
                            <Button onClick={async(e)=>{
                                e?.preventDefault()
                                await handleMatch()
                            }} disabled={matching} sx={{background:"#ff0",color:"#000",margin:1,height:30,fontFamily:"dinofans",fontSize:12}} variant="outlined">
                                {
                                    matching ? <CircularProgress sx={{color:"#000"}} size={15}/> : "Match"
                                }
                            </Button> 
                        </Box>                                
                    </>
                   } 
                </Box>		
			</ContainerBox>
        </DialogContent>
	</Dialog>
	)
}

export default MatchDialog